import { Swiper } from 'swiper';
import { A11y, Autoplay } from 'swiper/modules';

const sliders = document.querySelectorAll('.block-logo-rows .swiper');
const swiperInstances = {};

const initializeSliders = () => {
	sliders.forEach((slider, index) => {
		const slides = slider.querySelectorAll('.swiper-slide');
		slider.setAttribute('data-slider-index', index);

		if (window.innerWidth >= 768 && slides.length <= 6) {
			if (swiperInstances[index] instanceof Swiper) {
				swiperInstances[index].destroy(true, true);
				delete swiperInstances[index];
			}

			return;
		}

		if (swiperInstances[index] instanceof Swiper) {
			return;
		}

		slider
			.closest('.block-logo-rows')
			.classList.add(`block-logo-rows--${index}`);

		const settings = {
			loop: false,
			grabCursor: true,
			spaceBetween: 8,
			slidesPerView: 2,
			modules: [A11y, Autoplay],
			a11y: {
				itemRoleDescriptionMessage: 'slide',
			},
			breakpoints: {
				768: {
					slidesPerView: 4,
					loop: true,
					speed: 1500,
					autoplay: {
						delay: 0,
						disableOnInteraction: false,
					},
					freeMode: {
						enabled: true,
						sticky: false,
						momentum: true,
						momentumBounce: false,
					},
				},
				992: {
					slidesPerView: 5,
					loop: true,
					speed: 1500,
					autoplay: {
						delay: 0,
						disableOnInteraction: false,
					},
					freeMode: {
						enabled: true,
						sticky: false,
						momentum: true,
						momentumBounce: false,
					},
				},
				1200: {
					slidesPerView: 6,
					loop: true,
					speed: 1500,
					autoplay: {
						delay: 0,
						disableOnInteraction: false,
					},
					freeMode: {
						enabled: true,
						sticky: false,
						momentum: true,
						momentumBounce: false,
					},
				},
			},
		};

		swiperInstances[index] = new Swiper(slider, settings);

		if (slides.length > 6) {
			const sliderWraper = slider.querySelector('.swiper-wrapper');

			sliderWraper.addEventListener('mouseenter', () => {
				const sliderIndex = slider?.dataset?.sliderIndex;

				if (
					!sliderIndex === undefined ||
					!swiperInstances[sliderIndex]
				) {
					return;
				}

				swiperInstances[sliderIndex].autoplay.start();
			});

			sliderWraper.addEventListener('mouseleave', () => {
				const sliderIndex = slider?.dataset?.sliderIndex;

				if (
					!sliderIndex === undefined ||
					!swiperInstances[sliderIndex]
				) {
					return;
				}

				swiperInstances[sliderIndex].autoplay.stop();
			});
		}
	});
};

initializeSliders();

window.addEventListener('propel-viewport-changed-md', initializeSliders);
window.addEventListener('propel-viewport-changed-lg', initializeSliders);
